export default "__VITE_ASSET__uLBPD_1m__"